import React, { useEffect, useState } from "react";
import Modal from "./Modal";

type SaveModalProps = {
    open: boolean;
    onClose: () => void;
    onSave: (name: string) => void;
    defaultName?: string;
    isSaving?: boolean;
};

const SaveModal: React.FC<SaveModalProps> = ({ open, onClose, onSave, defaultName = "", isSaving = false }) => {
    const [name, setName] = useState(defaultName);

    useEffect(() => {
        if (open) setName(defaultName);
    }, [open, defaultName]);

    const handleSave = () => {
        if (!name.trim()) return;
        onSave(name.trim());
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Sauvegarder l'horaire"
            size="md"
            footer={
                <>
                    <button
                        onClick={onClose}
                        className="inline-flex items-center rounded-full bg-gray-200 cursor-pointer px-4 py-2 font-medium text-gray-700 hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                    >
                        Annuler
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={isSaving || !name.trim()}
                        className={`inline-flex items-center rounded-full bg-blue-600 px-4 py-2 font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${isSaving || !name.trim() ? "opacity-50 cursor-not-allowed" : "cursor-pointer hover:bg-blue-700"}`}
                    >
                        {isSaving ? "Sauvegarde..." : "Sauvegarder"}
                    </button>
                </>
            }
        >
            <label className="block text-sm font-medium text-gray-700 mb-1">
                Nom de la sauvegarde
            </label>
            <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") handleSave(); }}
                placeholder="ex: 2026-03-13-15h50"
                autoFocus
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
        </Modal>
    );
};

export default SaveModal;
